{
  "roles": {
    "owner": "Dueño",
    "admin": "Admin",
    "member": "Miembro",
    "guest": "Invitado"
  },
  "role_desc": {
    "admin": "Gestiona miembros, proyectos y facturación.",
    "member": "Crea y edita proyectos y tareas del equipo.",
    "guest": "Solo accede a lo que explícitamente se le comparte."
  },
  "priority": {
    "low": "Baja",
    "medium": "Media",
    "high": "Alta",
    "urgent": "Urgente"
  },
  "members": {
    "title": "Miembros del equipo",
    "subtitle": "Gestiona quién tiene acceso a {team} y qué puede hacer.",
    "invite_person": "Invitar persona",
    "stat_members": "Miembros",
    "stat_plan": "Plan actual",
    "stat_attention": "Atención",
    "stat_available": "Espacio disponible",
    "unlimited_plan": "Sin límite en este plan.",
    "near_limit": "Estás cerca del límite. Considera actualizar a un plan superior.",
    "can_add_more": "Puedes agregar {n} más.",
    "search_placeholder": "Buscar por nombre o email…",
    "loading": "Cargando miembros…",
    "no_match": "Nadie coincide con \"{q}\".",
    "no_members": "Sin miembros aún.",
    "you": "Tú",
    "joined_on": "Se unió el {date}",
    "action_on": "Acciones sobre {name}",
    "remove_from_team": "Quitar del equipo",
    "owner_only_note": "Solo el dueño del equipo puede cambiar roles o quitar miembros.",
    "confirm_remove_title": "¿Quitar a {name} del equipo?",
    "confirm_remove_message": "Perderá acceso inmediatamente a todos los proyectos y tareas de este equipo.",
    "error_change_role": "No se pudo cambiar el rol.",
    "error_remove_member": "No se pudo quitar al miembro."
  },
  "profile": {
    "back_to_members": "Volver a miembros",
    "loading": "Cargando perfil…",
    "error_load": "No se pudo cargar el perfil.",
    "member_since": "Miembro desde {date}",
    "no_team": "Sin equipo",
    "create_new_team": "Crear nuevo equipo",
    "team_name_placeholder": "Nombre del equipo",
    "create_and_assign": "Crear y asignar",
    "delete_team_title": "¿Eliminar el equipo \"{name}\"?",
    "delete_team_message": "Los miembros asignados quedarán sin equipo.",
    "delete_team_action": "Eliminar {name}",
    "error_assign_team": "No se pudo asignar el equipo.",
    "error_create_team": "No se pudo crear el equipo.",
    "error_delete_team": "No se pudo eliminar.",
    "stats": {
      "open": "Abiertas",
      "completed": "Completadas",
      "completed_period": "Últimos 30 días",
      "overdue": "Atrasadas",
      "projects": "Proyectos"
    },
    "tasks_title": "Tareas asignadas",
    "open_count": "Abiertas ({n})",
    "completed_recent": "Completadas recientes ({n})",
    "no_tasks": "Sin tareas asignadas en este equipo.",
    "projects_title": "Proyectos ({n})",
    "no_projects": "No está en ningún proyecto.",
    "task_count_one": "{n} tarea",
    "task_count_other": "{n} tareas",
    "view_all_tasks": "Ver todas",
    "tasks_of": "Tareas de {name}",
    "all_tasks_subtitle": "Todas las tareas asignadas en este espacio de trabajo",
    "back_to_profile": "Volver al perfil"
  },
  "department": {
    "loading": "Cargando equipo…",
    "error_load": "No se pudo cargar el equipo.",
    "back_to_teams": "Todos los equipos",
    "members_one": "{n} miembro",
    "members_other": "{n} miembros",
    "projects_one": "{n} proyecto",
    "projects_other": "{n} proyectos",
    "projects_section": "Proyectos",
    "new_project": "Nuevo proyecto",
    "no_projects": "Este equipo aún no tiene proyectos.",
    "create_first": "Crea el primero",
    "private_label": "Privado",
    "no_description": "Sin descripción.",
    "tasks_one": "{n} tarea",
    "tasks_other": "{n} tareas",
    "members_section": "Miembros",
    "add_member": "Añadir miembro",
    "no_members": "Aún no hay miembros en este equipo.",
    "add_first": "Añadir el primero",
    "remove_from_dept": "Quitar del equipo",
    "confirm_remove_member": "¿Quitar a {name} del equipo {dept}?",
    "error_load_members": "Error cargando miembros.",
    "error_add_member": "Error añadiendo miembro.",
    "error_remove_member": "Error quitando miembro.",
    "error_create_project": "Error al crear el proyecto.",
    "modal_new_project_title": "Nuevo proyecto",
    "modal_team_label": "Equipo:",
    "field_name": "Nombre",
    "field_description": "Descripción",
    "field_color": "Color",
    "private_project": "Proyecto privado",
    "private_project_help": "Solo miembros explícitos pueden verlo, ignorando el equipo.",
    "cancel": "Cancelar",
    "creating": "Creando…",
    "create_project": "Crear proyecto",
    "modal_add_members_title": "Añadir miembros",
    "modal_add_members_subtitle": "Asigna miembros del workspace al equipo {dept}.",
    "modal_search_placeholder": "Buscar por nombre o email…",
    "no_results": "Sin resultados.",
    "all_in_team": "Todos los miembros del workspace ya están en este equipo.",
    "add": "Añadir",
    "add_existing_project": "Agregar existente",
    "remove_project_from_dept": "Quitar del equipo",
    "confirm_remove_project": "¿Quitar el proyecto {name} del equipo {dept}?",
    "error_load_projects": "Error cargando proyectos.",
    "error_add_project": "Error al agregar el proyecto.",
    "error_remove_project": "Error al quitar el proyecto.",
    "modal_add_projects_title": "Agregar proyectos",
    "modal_add_projects_subtitle": "Vincula proyectos del workspace al equipo {dept}.",
    "modal_search_project_placeholder": "Buscar proyecto por nombre…",
    "no_projects_to_add": "No hay otros proyectos para agregar.",
    "currently_in": "Actualmente en {dept}",
    "tab_boards": "Tableros",
    "tab_tasks": "Tareas"
  },
  "tasks": {
    "loading": "Cargando tareas…",
    "error_load": "No se pudieron cargar las tareas del equipo.",
    "empty": "No hay tareas que coincidan con los filtros.",
    "status_all": "Todas",
    "status_pending": "Pendientes",
    "status_open": "Abiertas",
    "status_in_progress": "En progreso",
    "status_done": "Completadas",
    "status_cancelled": "Canceladas",
    "overdue_n": "{n} vencidas",
    "search_placeholder": "Buscar tarea…",
    "filter_all_members": "Todos los miembros",
    "filter_unassigned": "Sin asignar",
    "filter_all_priorities": "Toda prioridad",
    "filter_all_boards": "Todos los tableros",
    "clear_filters": "Limpiar filtros",
    "page_of": "Página {current} de {total}",
    "prev": "Anterior",
    "next": "Siguiente"
  }
}
